import { useMemo } from "react";
import styles from "./styles.module.css";
import Tooltip from "../../../Tooltip/Tooltip";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import PropTypes from "prop-types";

const InfoItem = ({
  label,
  value,
  valuePlaceholder,
  imageUrl,
  itemStyle,
  valueType,
  toolTipLabel,
  toolTipIcon,
  toolTipPosition,
  loader = false,
  titleMoreInfo,
  titleMoreIcon,
}) => {
  const openImage = (base64) => {
    const byteString = atob(base64.split(",")[1]);
    const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeString });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  const formattedValue = useMemo(() => {
    if (value) {
      if (valueType == "dateTime_hhmm") {
        return moment.utc(value).local().format("DD.MM.YYYY HH:mm");
      } else if (valueType == "dateTime_hhmmss") {
        return value || "N/A";
      } else if (valueType == "original-date") {
        return moment.utc(value).format("DD.MM.YYYY");
      } else if (valueType == "date") {
        return moment.utc(value).local().format("DD.MM.YYYY");
      } else if (valueType == "original-time") {
        return moment(value, "HH:mm:ss.SSS").format("HH:mm");
      } else if (valueType == "time") {
        return moment.utc(value, "HH:mm:ss.SSS", true).local().format("HH:mm");
      } else if (valueType == "link") {
        return (
          <a href={value} target="_blank" rel="noopener noreferrer">
            {valuePlaceholder || label}
          </a>
        );
      } else {
        return value || "N/A";
      }
    } else if (imageUrl) {
      return (
        <button
          className={styles["viewBtn"]}
          onClick={(e) => {
            e.preventDefault();
            openImage(imageUrl);
          }}
        >
          View
        </button>
      );
    } else {
      return "N/A";
    }
  }, [value, valueType, imageUrl]);
  return (
    <>
      <div className={`${styles["grid-item"]} ${itemStyle || ""}`}>
        <div className="d-flex align-items-center" style={{ gap: 5 }}>
          {toolTipLabel ? (
            <Tooltip position="pos-25" text={"Date format: DD.MM.YYYY"}>
              <h5 className={styles["grid-item-label"]}>{label}:</h5>
            </Tooltip>
          ) : (
            <h5 className={styles["grid-item-label"]}>{label}:</h5>
          )}
          {titleMoreInfo && (
            <Tooltip position="pos-25" text={titleMoreInfo}>
              {titleMoreIcon}
            </Tooltip>
          )}
        </div>
        {loader ? (
          <Skeleton width={150} />
        ) : (
          <p className={styles["grid-item-value"]}>
            {formattedValue}
            <span className="ms-1">
              {toolTipLabel && (
                <Tooltip
                  position={toolTipPosition}
                  text={`${
                    valueType === "dateTime_hhmm"
                      ? moment(toolTipLabel).isSame(
                          moment(toolTipLabel).startOf("day"),
                        )
                        ? moment.utc(toolTipLabel).format("DD.MM.YYYY")
                        : moment.utc(toolTipLabel).format("DD.MM.YYYY HH:mm")
                      : moment.utc(toolTipLabel, "HH:mm:ss.SSS").format("HH:mm")
                  } UTC`}
                >
                  {toolTipIcon}
                </Tooltip>
              )}
            </span>
          </p>
        )}
      </div>
    </>
  );
};

InfoItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  imageUrl: PropTypes.string,
  itemStyle: PropTypes.string,
  valueType: PropTypes.string,
  toolTipLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  toolTipIcon: PropTypes.node,
  toolTipPosition: PropTypes.string,
  loader: PropTypes.bool,
  titleMoreInfo: PropTypes.string,
  titleMoreIcon: PropTypes.node,
  valuePlaceholder: PropTypes.string,
};

InfoItem.defaultProps = {
  value: null,
  imageUrl: null,
  itemStyle: "",
  valueType: "",
  toolTipLabel: null,
  toolTipIcon: null,
  toolTipPosition: "right",
  loader: false,
  titleMoreInfo: null,
  titleMoreIcon: null,
  valuePlaceholder: "",
};

export default InfoItem;
